<template>
    <div class="container mx-6 my-6 has-text-centered">
        <h2 class="subtitle">Loading...</h2>
        <progress class="progress is-small is-primary" max="100">loading</progress>   
    </div>
</template>
<script>
import firebase from "firebase/app"
import { mapActions } from "vuex";
export default {
    methods:{
        ...mapActions({ storeCurrentUser: "storeCurrentUser"})
    },
    created() {
        firebase.auth().signOut()
        this.storeCurrentUser(null).then( () => {
            this.$router.push('/') 
         })
        
    }
}
</script>